import React from 'react';
import Svg from "../../../component/Svg";
import { toast } from 'react-toastify'; 

const ExportExcel = ({ selectedRows }) => {
  const handleExport = async () => {
    if (selectedRows.length === 0) {
      toast.error('Please select rows to export.');
      return; // Stop further execution
    }
    try {
      const xlsx = await import('xlsx');
      const worksheet = xlsx.utils.json_to_sheet(selectedRows);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      saveAsExcelFile(excelBuffer, 'RoiCalculatorExport');
    } catch (error) {
      console.error('Error exporting Excel:', error);
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      const EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });

      module.default.saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  };

  return (
    <button className="btn btn-bordered ms-md-2 mt-2 mt-md-0 d-inline-flex align-items-center with-icon gap-10" onClick={handleExport}>
      <Svg name="export" /> Export
    </button>
  );
};

export default ExportExcel;
